interface TextAreaFieldProps {
  id: string;
  name: string;
  label: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  rows?: number;
  error?: string;
}

export default function TextAreaField({
  id,
  name,
  label,
  placeholder,
  value,
  onChange,
  rows = 4,
  error,
}: TextAreaFieldProps) {
  return (
    <div className="space-y-2">
      <label htmlFor={id} className="block text-sm font-medium text-text-primary">
        {label}
      </label>
      <textarea
        id={id}
        name={name}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary transition-smooth resize-none ${
          error ? 'border-error' : 'border-input'
        }`}
      />
      {error && <p className="text-xs text-error">{error}</p>}
    </div>
  );
}